import axios from 'axios'

export const state = {
  roles : {},
  role : {}
}

export const getters = {
  listRoles (state) {
    return state.roles
  },
  detailRole (state) {
    return state.role
  },
}

export const mutations = {
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  SET_ROLE (state, role) {
    state.role = role
  },
  TOGGLE_SHOW_DETAIL(state, id) {
    state.roles.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.roles.data.splice(index, 1)
        state.roles.data.splice(index, 0, item)
      }
    });
  },
}

export const actions = {
  getRoles({ commit }, params = {}) {
    return axios.get(`/roles/search`, { params }).then(({ data }) => {
      return commit('SET_ROLES', data)
    })
  },
  getListRoles({ commit }, params = {}) {
    return axios.get(`/roles/search`, { params })
  },
  getRole({ commit }, id) {
    return axios.get(`/roles/${id}`);
  },
  createRole({ commit }, data) {
    return axios.post('/roles', data)
  },
  updateRole({ commit }, role) {
    const data = {
      name: role.name,
      status: role.status,
      permission_ids: role.permission_ids
    }

    return axios.put(`/roles/${role.id}`, data)
  },
  exportRolesCsv({commit}) {
    return axios.get('/roles/export');
  },
  toggleRoleDataDetails: function ({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
}
